import * as React from "react";
import AutoCompleteParceiro from "../../pages/parceiros/autoCompleteParceiro";
import { hasInCache } from "../../helper/cacheHelper";
import Parceiro from "../classes/Parceiro";
import Typography from '@mui/material/Typography';
import ViewListIcon from '@mui/icons-material/ViewList';
import IconButton from '@mui/material/IconButton';
import { Box, Chip, Tooltip } from "@mui/material";
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PropriedadeParceiroDataSet from '../data/PropriedadeParceiroDataSet';
import { useTranslation } from "react-i18next";

function ParceiroHeader() {
    const { t } = useTranslation();

    const [parceiro, setParceiro] = React.useState(new Parceiro());
    const [show, SetShow] = React.useState(false);
    const [hasPartner, setHasPartner] = React.useState(false);

    React.useEffect(() => {
        const checkPartner = () => {
            if (hasInCache("CodigoFornecedorSAPSelecionado")) {
                var parca: Parceiro = JSON.parse(String(localStorage.getItem("ParceiroSelecionado")));
                var dataSetPP: PropriedadeParceiroDataSet = new PropriedadeParceiroDataSet();
                dataSetPP.ListarAtivos(Number(localStorage.getItem("CodigoFornecedorSAPSelecionado"))).then((response) => {
                    dataSetPP.AdicionarListaAoCache(response);
                });

                setParceiro(parca);
                setHasPartner(true);
                SetShow(false);
            } else {
                setHasPartner(false);
                SetShow(true);
            }
        };

        checkPartner();

        const handlePartnerChange = () => {
            checkPartner();
        };

        window.addEventListener('partnerSelected', handlePartnerChange);
        window.addEventListener('storage', handlePartnerChange);

        return () => {
            window.removeEventListener('partnerSelected', handlePartnerChange);
            window.removeEventListener('storage', handlePartnerChange);
        };
    }, []);

    const buttonClick = () => {
        localStorage.removeItem("CodigoFornecedorSAPSelecionado");
        localStorage.removeItem("ParceiroSelecionado");
        localStorage.removeItem("GrupoParceiroSelecionado");
        setHasPartner(false);
        SetShow(true);
    }

    const handlePartnerSelected = () => {
        SetShow(false);
        setHasPartner(hasInCache("CodigoFornecedorSAPSelecionado"));
        
        if (hasInCache("CodigoFornecedorSAPSelecionado")) {
            const parca: Parceiro = JSON.parse(String(localStorage.getItem("ParceiroSelecionado")));
            setParceiro(parca);
            // Disparar evento para avisar outros componentes
            window.dispatchEvent(new Event('partnerSelected'));
        }
    };

    return (
        <Box display="flex" alignItems="center" gap={1}>
            {show ? (
                <Box sx={{ minWidth: 250 }}>
                    <AutoCompleteParceiro 
                        label={t("header.partner")} 
                        cacheKey='ParceiroCache' 
                        size='small' 
                        montaCache={true}
                    />
                </Box>
            ) : (
                <>
                    {!hasPartner || !parceiro.nome ? (
                        <Chip
                            icon={<WarningAmberIcon />}
                            label={t("header.selectPartner") || "Selecione um Parceiro"}
                            color="warning"
                            variant="outlined"
                            onClick={buttonClick}
                            sx={{ 
                                cursor: 'pointer',
                                animation: 'pulse 2s infinite',
                                '@keyframes pulse': {
                                    '0%, 100%': { opacity: 1 },
                                    '50%': { opacity: 0.7 }
                                }
                            }}
                        />
                    ) : (
                        <>
                            <Chip
                                icon={<CheckCircleIcon />}
                                label={`${parceiro.codigoFornecedorSAP} - ${parceiro.grupo}`}
                                color="success"
                                variant="outlined"
                                sx={{ maxWidth: 300 }}
                            />
                            <Tooltip title={t("header.partnerTooltip") || "Trocar Parceiro"}>
                                <IconButton 
                                    aria-label="MostraLista" 
                                    component="span" 
                                    onClick={buttonClick}
                                    size="small"
                                >
                                    <ViewListIcon />
                                </IconButton>
                            </Tooltip>
                        </>
                    )}
                </>
            )}
        </Box>
    );
}

export default ParceiroHeader;
